import DataPolicyModule from "../modules/data-policy/DataPolicyModule";

const DataPolicyPage = () => {
  return <DataPolicyModule />;
};

export default DataPolicyPage;
